<script setup lang="ts">
import CiModalFooter from '@/components/CiModal/CiModalFooter.vue';
import CiModalHeader from '@/components/CiModal/CiModalHeader.vue';

/********************
 * PROPS & EMITS     *
 ********************/
export interface CiFilterResetModalProps {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  applyChanges: Function;
}
const props = withDefaults(defineProps<CiFilterResetModalProps>(), {});

const emit = defineEmits<{
  close: [];
}>();

/********************
 * COMPOSITIONS      *
 ********************/
const { $gettext } = useGettext();

/********************
 * REFS & VARS       *
 ********************/
const modalTitle = computed(() => {
  return $gettext('Discard changes?');
});
</script>

<template>
  <div class="rounded-lg bg-white shadow-2xl">
    <CiModalHeader
      :title="modalTitle"
      @modal-close="emit('close')"
    />

    <div class="modal-body p-6">
      <span>{{ $gettext('You are about to reset your filters and discard your previous input:') }}</span>
    </div>

    <CiModalFooter class="flex flex-col justify-between p-4 md:flex-row">
      <CiButton
        tag="button"
        variant="text"
        class="order-2 mr-0 w-full md:order-1 md:mr-2 md:w-1/2"
        @click="emit('close')"
      >
        {{ $gettext('No') }}
      </CiButton>
      <CiButton
        tag="button"
        class="order-1 mb-2 ml-0 w-full md:order-2 md:mb-0 md:ml-2 md:w-1/2"
        @click="props.applyChanges"
      >
        {{ $gettext('Yes, apply') }}
      </CiButton>
    </CiModalFooter>
  </div>
</template>
